// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router,routerGo} from './router'
import $ from 'jquery'
import 'normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import waterfall from 'vue-waterfall2'
import api from './fetch/api'



Vue.use(waterfall)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$api = api;
Vue.prototype.$routeGo = routerGo;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js